import { FC } from 'react';

import { RelativeTime } from '@bonusly/common-relative-time';
import { RichTextDisplay } from '@bonusly/common-rich-text-editor';
import { Box, Flex, rem, StyleProps, Text } from '@bonusly/design-system';

import { UserAvatar } from '../user/user-avatar';

interface CompleteMessageProps extends StyleProps {
	date: Date;
	text: string;
	userId: string;
	userName: string;
}

const isHTML = (source: string) => {
	return /<[a-z][\s\S]*>/i.test(source);
};

export const CompleteMessage: FC<CompleteMessageProps> = ({ date, text, userId, userName, ...rest }) => {
	return (
		<Flex columnGap={4} {...rest}>
			<Box flexBasis={rem(40)}>
				<UserAvatar userId={userId} />
			</Box>

			<Box flexGrow={1}>
				<Flex alignItems="center">
					<Text as="span" size="md" fontWeight="bold" mr={2}>
						{userName}
					</Text>
					<RelativeTime date={date} fontSize="sm" />
				</Flex>
				<Text as="div" size="md" whiteSpace="pre-wrap">
					{/* Early feedback was given in the form of plain text, which responds to the above pre-wrap
					style attribute for displaying newlines. A simple RegEx check will render just the text if
					it does not start with an HTML tag, which would instead denote a string of rich text */}
					{isHTML(text) ? <RichTextDisplay key={text}>{text}</RichTextDisplay> : text}
				</Text>
			</Box>
		</Flex>
	);
};
